/* eslint-disable no-unused-expressions */
import React, { useState } from "react";
import * as locations_ from "../../CatalogLocations/operations";
import Lightbox from "react-awesome-lightbox";
import PDFExport from "../../../helper/export-pdf";
import "react-awesome-lightbox/build/style.css";

import {
  Card,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import moment from "moment";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { useHistory } from "react-router-dom";

import Map from "../../../../_metronic/layout/components/mapbox/dualMode";

export default function Products(props) {
  const report = props.rows

  const pos_visited = [...new Set(report.filter(Boolean).map(row => String(row.pos).toUpperCase()))]
  const _products = props.pos.map((doc, key) => {
    return {
      ...doc,
      no: Number(key) + 1
    };
  });
  const history = useHistory();
  const default_image = "https://firebasestorage.googleapis.com/v0/b/gto-mkt-dev.appspot.com/o/location.jpeg?alt=media&token=140223c7-ceda-4618-ba74-5750a3be2dd7"
  const [filter, setFilter] = useState("")
  const [isOpen, setOpen] = useState(false);
  const [content, setContent] = useState("");
  const columns = locations_.columns.map((col) => {
    col.formatExtraData = {
      controller: (location) => {
        setOpen(true);
        setContent(
          location.image || process.env.REACT_APP_DEFAULT_LOCATION_IMAGE
        );
      },
    };
    return col;
  });
  // const totalizer_cols = ["cost", "price", "available", "reserved"]
  // const money_cols = ["cost", "price"]
  const cols = columns.filter(
    (col) => col.text.toLocaleLowerCase() !== "actions"
  );
  const documents = _products
    .filter(client => client.name.toUpperCase().includes(filter.toUpperCase()) || !filter)
    .map((doc, i) => ({
      no: Number(i) + 1,
      visited: pos_visited.includes(doc.name.toUpperCase()),
      ...doc,
      region: "",

    }))
  return (
    <Card className="p-4 rounded-xl shadow-sm" style={{ minHeight: "600px" }}>
      {isOpen && (
        <Lightbox
          image={content}
          onClose={() => {
            setOpen(false);
            setContent("");
          }}
        />
      )}
      <Container fluid>
        <Row className="w-100 justify-content-between p-2">
          <div className="col-6 w-100 justify-content-end d-flex ">
            <h1>
              POS
            </h1>
          </div>
          <PDFExport
            columns={cols.map(col => col.dataField).filter(col => col !== "image")}
            data={_products}
            name="locations"
            sign={
              props.campaign.name +
              "\n" +
              moment(props.campaign.start_date).format("MMMM/DD/YY") +
              "-" +
              moment(props.campaign.end_date).format("MMMM/DD/YY")
            }
          >
            <button className="btn btn-warning font-weight-bolder mx-2">
              Export Data
            </button>
          </PDFExport>
        </Row>

        <Row>
          <Col>
            <div className="col-lg-3">

              <input
                type="text"
                className="form-control"
                name="searchText"
                placeholder="Search"
                onChange={({ target }) => {
                  const { value } = target;
                  setFilter(value)
                }}
              />
              <small className="text-muted">Search locations</small>
            </div>
            <Container className="form form-label-right w-100 p-2" fluid>
              {!props.queryng ? <Row>
                <Col xs={4} style={{ overflow: "scroll", height: "620px" }}>

                  {documents.length ? documents
                    .sort((a, b) => {
                      if (a.name > b.name) { return 1 }
                      if (a.name < b.name) { return -1 }
                      return 0
                    })
                    .map(client => {
                      return (
                        <Card className="m-3 p-3 shadow-sm zoom">
                          <Row>
                            <Col xs={4}>
                              <img src={client.image ?? default_image} alt={client.name} width="100%" className="rounded" />
                            </Col>
                            <Col>

                              <h6>
                                <span
                                  className="pointer-hover"
                                  onClick={() => {
                                    history.push({
                                      pathname: "/pos/" + client.uid
                                    })
                                  }}>{client.name}</span>
                                <span className="text-muted">, {client.address}</span>
                              </h6>
                              <span className="row">
                                <div className="col-2">
                                  <hr
                                    style={{
                                      height: "3px",
                                      width: "30px",
                                      borderTop: `5px solid ${client.visited ? "green" : "red"}`,
                                    }}
                                  />
                                </div>
                                <div className="col-8" style={{ paddingTop: "5px" }}>
                                  <strong>{client.state}</strong>
                                </div>
                              </span>
                              {client.contact && <><label><strong>Contact:</strong> </label> {client.contact}, <span className="ml-2 text-muted">{client.phone}, {client.email}</span></>}                              </Col>

                          </Row>

                        </Card>
                      )
                    }) : <div className="d-flex text-center w-100 pt-5">
                    <h3 className="text-muted" >No Customer to show</h3>
                  </div>}
                </Col>
                <Col>

                  <Map
                    height="600px"
                    zoom={3}
                    preview={true}
                    pos={documents}
                  />
                </Col>
              </Row> : <div className="d-flex align-items-center pl-5 ml-5">
                <div className="mr-2">Loading...</div>
                <div className="spinner spinner-primary mr-10"></div>
              </div>}
            </Container>
          </Col>
        </Row>
      </Container>
    </Card>
  );
}